module.exports = __webpack_public_path__ + "static/img/pic3.21fd261.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd110/pic3.png
// module id = WV0b
// module chunks = 1